// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/quest/ox_greet_bubble.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qt-page-picture-quiz {
  background: #fffdf2;
}

.picture-quiz,
.picture-quiz-greeting,
.picture-quiz-verdict {
  --picture-u: calc(100vw / 1920);
  position: absolute;
  inset: 0;
  overflow: hidden;
  box-sizing: border-box;
  font-family: 'GosanjaOTF', 'Katuri', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.picture-quiz {
  padding: calc(50 * var(--picture-u));
  background: #fbffe9;
  color: #6e4417;
}

.picture-quiz--question,
.picture-quiz--choices {
  display: flex;
  flex-direction: column;
  gap: calc(50 * var(--picture-u));
}

.picture-quiz__question-banner {
  position: relative;
  flex: 0 0 calc(330 * var(--picture-u));
  min-height: 0;
  display: grid;
  place-items: center;
  border-radius: calc(80 * var(--picture-u));
  background: #fff7dc;
  box-shadow: inset 0 0 calc(35 * var(--picture-u)) rgba(229, 208, 143, 0.08);
}

.picture-quiz__question-banner h1 {
  position: relative;
  z-index: 2;
  margin: 0;
  max-width: calc(1320 * var(--picture-u));
  padding: 0 calc(40 * var(--picture-u));
  font-size: calc(64 * var(--picture-u));
  line-height: 1.2;
  font-weight: 900;
  color: #6e4417;
  text-align: center;
  word-break: keep-all;
}

.picture-quiz__question-banner--with-character {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 calc(300 * var(--picture-u));
  box-sizing: border-box;
}

.picture-quiz__question-banner--with-character h1 {
  width: 100%;
}

.picture-quiz__question-icon {
  position: absolute;
  z-index: 2;
  left: calc(70 * var(--picture-u));
  top: 50%;
  transform: translateY(-50%);
  width: calc(240 * var(--picture-u));
  height: calc(240 * var(--picture-u));
  object-fit: contain;
  filter: drop-shadow(0 calc(5 * var(--picture-u)) calc(5 * var(--picture-u)) rgba(91, 63, 18, 0.08));
}

.picture-quiz__question-stage {
  position: relative;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  border-radius: calc(60 * var(--picture-u));
  background: #edf5d8;
}

.picture-quiz__question-video {
  position: absolute;
  inset: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 120ms linear;
}

.picture-quiz__question-video.is-playing {
  opacity: 1;
}

.picture-quiz__choices {
  flex: 1 1;
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: calc(40 * var(--picture-u));
}

.picture-quiz__choice {
  position: relative;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  border: 0;
  border-radius: calc(70 * var(--picture-u));
  background: #edf5d8;
  box-shadow: 0 calc(8 * var(--picture-u)) calc(18 * var(--picture-u)) rgba(40, 71, 25, 0.12);
  cursor: pointer;
  transition: transform 120ms ease, box-shadow 120ms ease;
}

.picture-quiz__choice:active {
  transform: scale(0.97);
  box-shadow: 0 calc(6 * var(--picture-u)) calc(14 * var(--picture-u)) rgba(40, 71, 25, 0.2);
}

.picture-quiz__choice video,
.picture-quiz__choice img {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: inherit;
  object-fit: cover;
  background: #edf5d8;
}

/* Android WebView가 자동 재생 직전에 그리는 회색 판·재생 아이콘을 노출하지 않는다. */
.picture-quiz__choice-video {
  opacity: 0;
  transition: opacity 120ms linear;
}

.picture-quiz__choice-video-playing {
  opacity: 1;
}

.picture-quiz__choice-text {
  position: absolute;
  z-index: 2;
  left: calc(24 * var(--picture-u));
  right: calc(24 * var(--picture-u));
  bottom: calc(44 * var(--picture-u));
  font-size: calc(60 * var(--picture-u));
  line-height: 1.1;
  font-weight: 900;
  color: #fff;
  text-align: center;
  text-shadow: 0 calc(4 * var(--picture-u)) calc(7 * var(--picture-u)) rgba(43, 37, 20, 0.5);
  word-break: keep-all;
}

.picture-quiz__missing {
  display: grid;
  height: 100%;
  place-items: center;
  color: #8b2d25;
  font-size: calc(26 * var(--picture-u));
  font-weight: 800;
}

.picture-quiz-verdict {
  z-index: 30;
  display: grid;
  grid-template-rows: 1fr auto;
  justify-items: center;
  padding: calc(82 * var(--picture-u)) 0 calc(92 * var(--picture-u));
}

.picture-quiz-verdict--correct {
  background: #07851c;
}

.picture-quiz-verdict--wrong {
  background: #ff5c13;
}

.picture-quiz-verdict img {
  align-self: end;
  width: calc(560 * var(--picture-u));
  max-height: calc(820 * var(--picture-u));
  object-fit: contain;
  filter: drop-shadow(0 calc(18 * var(--picture-u)) calc(20 * var(--picture-u)) rgba(0, 0, 0, 0.24));
  animation: pictureVerdictPop 520ms cubic-bezier(0.2, 0.9, 0.25, 1.2) both;
}

.picture-quiz-verdict strong {
  margin-top: calc(20 * var(--picture-u));
  color: #fff;
  font-size: calc(72 * var(--picture-u));
  text-shadow: 0 calc(6 * var(--picture-u)) calc(10 * var(--picture-u)) rgba(0, 0, 0, 0.2);
}

.picture-quiz-greeting {
  background: radial-gradient(circle at 35% 35%, #fffef4 0%, #fbf8cf 58%, #f2efb4 100%);
}

.picture-quiz-greeting__timeline {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.picture-quiz-greeting__professor {
  position: absolute;
  left: calc(86 * var(--picture-u));
  top: calc(96 * var(--picture-u));
  width: calc(690 * var(--picture-u));
  height: calc(1010 * var(--picture-u));
  object-fit: contain;
  object-position: center bottom;
  filter: hue-rotate(224deg) saturate(1.05) brightness(0.96)
    drop-shadow(0 calc(14 * var(--picture-u)) calc(18 * var(--picture-u)) rgba(99, 69, 28, 0.16));
}

.picture-quiz-greeting__bubble {
  position: absolute;
  left: calc(782 * var(--picture-u));
  top: calc(70 * var(--picture-u));
  width: calc(1078 * var(--picture-u));
  height: calc(1090 * var(--picture-u));
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / contain;
  pointer-events: none;
}

.picture-quiz-greeting__name {
  position: absolute;
  left: calc(1001 * var(--picture-u));
  top: calc(176 * var(--picture-u));
  width: calc(686 * var(--picture-u));
  margin: 0;
  color: #ff5816;
  font-size: calc(120 * var(--picture-u));
  line-height: 1.3;
  text-align: center;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.picture-quiz-greeting__lines {
  position: absolute;
  left: calc(1001 * var(--picture-u));
  top: calc(510 * var(--picture-u));
  width: calc(686 * var(--picture-u));
  margin: 0;
  color: #189018;
  font-size: calc(120 * var(--picture-u));
  line-height: 1.3;
  text-align: center;
}

.picture-quiz-greeting__lines p {
  margin: 0;
}

.picture-quiz-state {
  position: absolute;
  inset: 0;
  display: grid;
  place-content: center;
  gap: 18px;
  background: #fff4d7;
  text-align: center;
  font-size: 26px;
}

.picture-quiz-state button {
  padding: 12px 22px;
  border: 0;
  border-radius: 12px;
  background: #176a2c;
  color: white;
  font: inherit;
}

@keyframes pictureVerdictPop {
  from { opacity: 0; transform: translateY(8%) scale(0.8); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}
`, "",{"version":3,"sources":["webpack://./src/components/quest/PictureQuizRunner.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,+BAA+B;EAC/B,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,sBAAsB;EACtB,8FAA8F;AAChG;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,2EAA2E;AAC7E;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,wCAAwC;EACxC,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iCAAiC;EACjC,QAAQ;EACR,2BAA2B;EAC3B,mCAAmC;EACnC,oCAAoC;EACpC,mBAAmB;EACnB,mGAAmG;AACrG;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,gDAAgD;EAChD,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,0CAA0C;EAC1C,mBAAmB;EACnB,2FAA2F;EAC3F,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;EACtB,0FAA0F;AAC5F;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,0DAA0D;AAC1D;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iCAAiC;EACjC,kCAAkC;EAClC,mCAAmC;EACnC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0FAA0F;EAC1F,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,qBAAqB;EACrB,kEAAkE;AACpE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,wCAAwC;EACxC,mBAAmB;EACnB,kGAAkG;EAClG,yEAAyE;AAC3E;;AAEA;EACE,uCAAuC;EACvC,WAAW;EACX,sCAAsC;EACtC,wFAAwF;AAC1F;;AAEA;EACE,qFAAqF;AACvF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,mCAAmC;EACnC,qCAAqC;EACrC,mBAAmB;EACnB,8BAA8B;EAC9B;iGAC+F;AACjG;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,gCAAgC;EAChC,oCAAoC;EACpC,qCAAqC;EACrC,8EAAqF;EACrF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,iCAAiC;EACjC,mCAAmC;EACnC,SAAS;EACT,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,iCAAiC;EACjC,mCAAmC;EACnC,SAAS;EACT,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,OAAO,UAAU,EAAE,oCAAoC,EAAE;EACzD,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD","sourcesContent":[".qt-page-picture-quiz {\n  background: #fffdf2;\n}\n\n.picture-quiz,\n.picture-quiz-greeting,\n.picture-quiz-verdict {\n  --picture-u: calc(100vw / 1920);\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  box-sizing: border-box;\n  font-family: 'GosanjaOTF', 'Katuri', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.picture-quiz {\n  padding: calc(50 * var(--picture-u));\n  background: #fbffe9;\n  color: #6e4417;\n}\n\n.picture-quiz--question,\n.picture-quiz--choices {\n  display: flex;\n  flex-direction: column;\n  gap: calc(50 * var(--picture-u));\n}\n\n.picture-quiz__question-banner {\n  position: relative;\n  flex: 0 0 calc(330 * var(--picture-u));\n  min-height: 0;\n  display: grid;\n  place-items: center;\n  border-radius: calc(80 * var(--picture-u));\n  background: #fff7dc;\n  box-shadow: inset 0 0 calc(35 * var(--picture-u)) rgba(229, 208, 143, 0.08);\n}\n\n.picture-quiz__question-banner h1 {\n  position: relative;\n  z-index: 2;\n  margin: 0;\n  max-width: calc(1320 * var(--picture-u));\n  padding: 0 calc(40 * var(--picture-u));\n  font-size: calc(64 * var(--picture-u));\n  line-height: 1.2;\n  font-weight: 900;\n  color: #6e4417;\n  text-align: center;\n  word-break: keep-all;\n}\n\n.picture-quiz__question-banner--with-character {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 calc(300 * var(--picture-u));\n  box-sizing: border-box;\n}\n\n.picture-quiz__question-banner--with-character h1 {\n  width: 100%;\n}\n\n.picture-quiz__question-icon {\n  position: absolute;\n  z-index: 2;\n  left: calc(70 * var(--picture-u));\n  top: 50%;\n  transform: translateY(-50%);\n  width: calc(240 * var(--picture-u));\n  height: calc(240 * var(--picture-u));\n  object-fit: contain;\n  filter: drop-shadow(0 calc(5 * var(--picture-u)) calc(5 * var(--picture-u)) rgba(91, 63, 18, 0.08));\n}\n\n.picture-quiz__question-stage {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  border-radius: calc(60 * var(--picture-u));\n  background: #edf5d8;\n}\n\n.picture-quiz__question-video {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0;\n  transition: opacity 120ms linear;\n}\n\n.picture-quiz__question-video.is-playing {\n  opacity: 1;\n}\n\n.picture-quiz__choices {\n  flex: 1;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: calc(40 * var(--picture-u));\n}\n\n.picture-quiz__choice {\n  position: relative;\n  min-width: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  border: 0;\n  border-radius: calc(70 * var(--picture-u));\n  background: #edf5d8;\n  box-shadow: 0 calc(8 * var(--picture-u)) calc(18 * var(--picture-u)) rgba(40, 71, 25, 0.12);\n  cursor: pointer;\n  transition: transform 120ms ease, box-shadow 120ms ease;\n}\n\n.picture-quiz__choice:active {\n  transform: scale(0.97);\n  box-shadow: 0 calc(6 * var(--picture-u)) calc(14 * var(--picture-u)) rgba(40, 71, 25, 0.2);\n}\n\n.picture-quiz__choice video,\n.picture-quiz__choice img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  border-radius: inherit;\n  object-fit: cover;\n  background: #edf5d8;\n}\n\n/* Android WebView가 자동 재생 직전에 그리는 회색 판·재생 아이콘을 노출하지 않는다. */\n.picture-quiz__choice-video {\n  opacity: 0;\n  transition: opacity 120ms linear;\n}\n\n.picture-quiz__choice-video-playing {\n  opacity: 1;\n}\n\n.picture-quiz__choice-text {\n  position: absolute;\n  z-index: 2;\n  left: calc(24 * var(--picture-u));\n  right: calc(24 * var(--picture-u));\n  bottom: calc(44 * var(--picture-u));\n  font-size: calc(60 * var(--picture-u));\n  line-height: 1.1;\n  font-weight: 900;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 calc(4 * var(--picture-u)) calc(7 * var(--picture-u)) rgba(43, 37, 20, 0.5);\n  word-break: keep-all;\n}\n\n.picture-quiz__missing {\n  display: grid;\n  height: 100%;\n  place-items: center;\n  color: #8b2d25;\n  font-size: calc(26 * var(--picture-u));\n  font-weight: 800;\n}\n\n.picture-quiz-verdict {\n  z-index: 30;\n  display: grid;\n  grid-template-rows: 1fr auto;\n  justify-items: center;\n  padding: calc(82 * var(--picture-u)) 0 calc(92 * var(--picture-u));\n}\n\n.picture-quiz-verdict--correct {\n  background: #07851c;\n}\n\n.picture-quiz-verdict--wrong {\n  background: #ff5c13;\n}\n\n.picture-quiz-verdict img {\n  align-self: end;\n  width: calc(560 * var(--picture-u));\n  max-height: calc(820 * var(--picture-u));\n  object-fit: contain;\n  filter: drop-shadow(0 calc(18 * var(--picture-u)) calc(20 * var(--picture-u)) rgba(0, 0, 0, 0.24));\n  animation: pictureVerdictPop 520ms cubic-bezier(0.2, 0.9, 0.25, 1.2) both;\n}\n\n.picture-quiz-verdict strong {\n  margin-top: calc(20 * var(--picture-u));\n  color: #fff;\n  font-size: calc(72 * var(--picture-u));\n  text-shadow: 0 calc(6 * var(--picture-u)) calc(10 * var(--picture-u)) rgba(0, 0, 0, 0.2);\n}\n\n.picture-quiz-greeting {\n  background: radial-gradient(circle at 35% 35%, #fffef4 0%, #fbf8cf 58%, #f2efb4 100%);\n}\n\n.picture-quiz-greeting__timeline {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.picture-quiz-greeting__professor {\n  position: absolute;\n  left: calc(86 * var(--picture-u));\n  top: calc(96 * var(--picture-u));\n  width: calc(690 * var(--picture-u));\n  height: calc(1010 * var(--picture-u));\n  object-fit: contain;\n  object-position: center bottom;\n  filter: hue-rotate(224deg) saturate(1.05) brightness(0.96)\n    drop-shadow(0 calc(14 * var(--picture-u)) calc(18 * var(--picture-u)) rgba(99, 69, 28, 0.16));\n}\n\n.picture-quiz-greeting__bubble {\n  position: absolute;\n  left: calc(782 * var(--picture-u));\n  top: calc(70 * var(--picture-u));\n  width: calc(1078 * var(--picture-u));\n  height: calc(1090 * var(--picture-u));\n  background: url('../../assets/quest/ox_greet_bubble.webp') no-repeat center / contain;\n  pointer-events: none;\n}\n\n.picture-quiz-greeting__name {\n  position: absolute;\n  left: calc(1001 * var(--picture-u));\n  top: calc(176 * var(--picture-u));\n  width: calc(686 * var(--picture-u));\n  margin: 0;\n  color: #ff5816;\n  font-size: calc(120 * var(--picture-u));\n  line-height: 1.3;\n  text-align: center;\n  word-break: break-word;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.picture-quiz-greeting__lines {\n  position: absolute;\n  left: calc(1001 * var(--picture-u));\n  top: calc(510 * var(--picture-u));\n  width: calc(686 * var(--picture-u));\n  margin: 0;\n  color: #189018;\n  font-size: calc(120 * var(--picture-u));\n  line-height: 1.3;\n  text-align: center;\n}\n\n.picture-quiz-greeting__lines p {\n  margin: 0;\n}\n\n.picture-quiz-state {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-content: center;\n  gap: 18px;\n  background: #fff4d7;\n  text-align: center;\n  font-size: 26px;\n}\n\n.picture-quiz-state button {\n  padding: 12px 22px;\n  border: 0;\n  border-radius: 12px;\n  background: #176a2c;\n  color: white;\n  font: inherit;\n}\n\n@keyframes pictureVerdictPop {\n  from { opacity: 0; transform: translateY(8%) scale(0.8); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
